import './SourceCitationChip.css';

export interface SourceCitationChipProps {
  /** Small leading glyph — only ever set for the live-capture chip in the
   *  reference mock ("◆ live · just now"); everyday source chips carry
   *  none ("from Layla @ CGF · email · Tue 2:14pm"). */
  glyph?: string;
  /** "live" for an in-progress Knot capture, or "from {who} @ {where}" /
   *  "{where}" for an already-landed source. */
  source: string;
  /** "just now", "Tue 2:14pm", etc. */
  when: string;
  /** Gold ONLY for a live Knot capture — neutral otherwise (locked rule:
   *  gold appears at most once per screen). */
  live?: boolean;
}

// Trust-posture primitive (1) — where a fact came from, always visible,
// never asserted without it.
export function SourceCitationChip({ glyph, source, when, live = false }: SourceCitationChipProps) {
  return (
    <span class={`citation-chip${live ? ' citation-chip--live' : ''}`}>
      {glyph ? <span class="citation-chip__glyph">{glyph}</span> : null}
      {source} · {when}
    </span>
  );
}
